import React, { Component } from "react";
import { connect } from "react-redux";
import style from "./style.module.scss";

class QuestionResult extends Component {
  render() {
    return (
      <div className={style.QuestionResult} hidden={this.props.hidden}>
        <div className={style.UpArrow}></div>
        {this.props.text.map((string, index) => (
          <p key={index}>{string}</p>
        ))}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  if (
    state.cscq[ownProps.question] &&
    state.cscq[ownProps.question].disabled.includes(ownProps.option)
  ) {
    return {
      hidden: false,
    };
  }
  return { hidden: true };
};

export const ResultsQuestionResult = connect(mapStateToProps)(QuestionResult);
